import { c, classy, m } from '@onfido/castor';
import React, { useCallback, useState, } from 'react';
import { useForwardedRef, withRef } from '../../../utils';
import { OptionList } from '../../option-list/option-list';
import { OptionListInit } from '../../option-list/options-list-init';
import { Popover } from '../../popover/popover';
import { NativeSelect } from '../native';
export const CustomSelect = withRef(function CustomSelect({ id, align = 'start', borderless, children, className, defaultValue, name, open: isOpen, position = 'bottom', onBlur, onClick, onKeyUp, onOpenChange, selectedIcon, value, ...restProps }, ref) {
    var _a, _b;
    const selectRef = useForwardedRef(ref);
    const [selected, setSelected] = useState({});
    const propagateOnChange = useCallback(() => {
        // propagate `onChange` manually because <select> won't naturally when its
        // value is changed programatically by React, and on next tick, because
        // React needs to update its value first
        setTimeout(() => { var _a; return (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new Event('change', { bubbles: true })); });
    }, []);
    const open = () => onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(true);
    const close = () => {
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(false);
        focus(selectRef.current);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(NativeSelect, { ...restProps, ref: selectRef, id: id, className: classy(m('absolute'), className), name: name, onBlur: (event) => {
                // if the Popover is open, focus is still inside Select
                // we don't want Field/Form validation to trigger
                if (isOpen)
                    event.stopPropagation();
                onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
            }, onClick: (event) => {
                isOpen ? close() : open();
                onClick === null || onClick === void 0 ? void 0 : onClick(event);
            }, onKeyUp: (event) => {
                if (openSelectKeys.has(event.key))
                    open();
                onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(event);
            }, "aria-controls": `${id}_options`, "aria-autocomplete": "list", "aria-expanded": isOpen }, !selected.value || React.createElement("option", { hidden: true, value: selected.value })),
        React.createElement("output", { className: classy(c('select-output')) },
            selected.option,
            "\u00A0 "),
        isOpen && (React.createElement(Popover, { align: align, className: classy(c('select-dropdown'), m({ borderless })), overlay: true, position: position, target: selectRef, onClose: close, onKeyUp: (event) => {
                if (closeSelectKeys.has(event.key))
                    close();
            }, onKeyDown: (event) => {
                // close if focus moves outside
                if (event.key === 'Tab') {
                    setTimeout(close);
                    event.preventDefault();
                }
            }, onRender: (element) => {
                var _a;
                // focus :checked option if :enabled, otherwise first :enabled
                focus((_a = element === null || element === void 0 ? void 0 : element.querySelector(':checked:enabled')) !== null && _a !== void 0 ? _a : element === null || element === void 0 ? void 0 : element.querySelector('input:enabled'));
            }, 
            // stop bubbling so that Field validation isn't affected
            onBlur: stopPropagation, onChange: stopPropagation, onInvalid: stopPropagation },
            React.createElement(OptionList, { id: `${id}_options`, defaultValue: defaultValue, icon: selectedIcon, name: name, value: (_b = (_a = selected.value) !== null && _a !== void 0 ? _a : value) !== null && _b !== void 0 ? _b : defaultValue, onChange: (selected) => {
                    setSelected(selected);
                    propagateOnChange();
                    close();
                } }, children))),
        !selected.option && (React.createElement(OptionListInit, { defaultValue: defaultValue, value: value, onInit: (selected) => {
                setSelected(selected);
                if (selected.value) {
                    propagateOnChange();
                }
            } }, children))));
});
const closeSelectKeys = new Set(['Escape']);
const openSelectKeys = new Set([' ', 'ArrowDown', 'ArrowUp']);
const focus = (element) => element === null || element === void 0 ? void 0 : element.focus({ preventScroll: true });
const stopPropagation = (event) => event.stopPropagation();
//# sourceMappingURL=custom-select.js.map